import {
  FETCH_INTEGRATION_CONFIG,
  FETCH_INTEGRATION_CONFIG_SUCCESS,
  FETCH_INTEGRATION_CONFIG_FAILED,
  EDIT_INTEGRATION_CONFIG
} from "../store/types";

const INITIAL_STATE = {
  integrationDetails: null,
  loading: false,
  error: { flag: false, msg: null }
};

export const integrationreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_INTEGRATION_CONFIG:
      return { ...state, loading: true };
    case FETCH_INTEGRATION_CONFIG_SUCCESS:
      return { ...state, integrationDetails: action.payload, loading: false };
    case FETCH_INTEGRATION_CONFIG_FAILED:
      // Use {} instead of null so guards like `!integrationDetails?.cpf?.enabled`
      // evaluate correctly (null means "still loading"; {} means "loaded but unavailable")
      return { ...state, integrationDetails: {}, loading: false, error: { flag: true, msg: action.payload } };
    case EDIT_INTEGRATION_CONFIG:
      return state;
    default:
      return state;
  }
};
